import { WarningRedIcon } from '@icons'
import { tr } from 'mmfintech-commons'

function WarningHeader() {
  return (
    <div className='account-warning__header'>
      <WarningRedIcon />
      {tr('PORTAL.COMPONENTS.ACCOUNT_WARNING.TITLE', 'Please note')}
    </div>
  )
}

export default WarningHeader
